import styled from 'styled-components';
import { UnstyledButton } from '../_Common/lot.common.styles';
import * as S from './content-header.styles';

export const UsersSpecs = styled(UnstyledButton)`
  display: flex;
  flex-direction: row;
  background: transparent;
  align-items: center;
  gap: 8px;
  width: min-content;
  min-width: 90px;
`
export const ButtonGroup = styled(S.ButtonGroup)`
  flex-direction: column;
`;
export const Button = styled(S.Button)`
  min-width: 90px;
`;
export const Wink = S.Wink;
export const Li = S.Li;
